import {jwtServerInstance} from "../index";
import qs from	'qs'

export const queryBusinessQuicklyData = () =>{
    return jwtServerInstance.request({
        url:'/b2cquicklydata/businessquicklydata',
        method:'post'
    })
}


export const queryAdminQuicklyData = () =>{
    return jwtServerInstance.request({
        url:'/b2cquicklydata/adminquicklydata',
        method:'post'
    })
}

//参数配置列表查询接口
export const queryTashNumbersWithStatus = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2cquicklydata/querytasknumbers',
        method:'post',
        data: qs.stringify({
            status:queryForm.status
        })
    })
}

//参数配置列表查询接口
export const queryAppealUnreviewNumbersWithStatus = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2cquicklydata/queryappealunreviewnumbers',
        method:'post',
        data: qs.stringify({
            status:queryForm.appealStatus
        })
    })
}

//参数配置列表查询接口
export const queryShopsNumbersWithStatus = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2cquicklydata/queryshopsnumbers',
        method:'post',
        data: qs.stringify({
            status:queryForm.reviewStatus
        })
    })
}

//参数配置列表查询接口
export const queryMsgNumbersWithStatus = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2cquicklydata/querymsgnumbers',
        method:'post',
        data: qs.stringify({
            msgStatus:queryForm.msgStatus
        })
    })
}


//参数配置列表查询接口
export const queryOrderNumbersWithStatus = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2cquicklydata/queryordernumbers',
        method:'post',
        data: qs.stringify({
            status:queryForm.status
        })
    })
}


//参数配置列表查询接口
export const queryIdcardNumbersWithStatus = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2cquicklydata/queryidcardnumbers',
        method:'post',
        data: qs.stringify({
            status:queryForm.status
        })
    })
}


//参数配置列表查询接口
export const queryBusinessWaitReturnMoneyNumbers = () => {
    return jwtServerInstance.request({
        url:'/b2cquicklydata/querywaitbrmoneynumbers',
        method:'post'
    })
}


//参数配置列表查询接口
export const queryCustomerAccountNumbers = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2cquicklydata/querycustomernumbers',
        method:'post',
        data: qs.stringify({
            status:queryForm.status
        })
    })
}
